module.exports = __webpack_public_path__ + "static/media/maf-02.1502e366.png";